import { TransferBaseModel } from '../transfer-base.model';

export interface UnionPayCard extends TransferBaseModel {
    account: string;
    id: string;
    payload: UnionPayCardDetail;
}

export interface UnionPayCardDetail {
    bank_province: string;
    bank_city: string;
    bank_branch: string;
    bank_name: string;
    bank_telephone: string;
    card_number: string;
    confirmed: string;
    contact_info: string;
    created: string;
    label: string;
    name: string;
    state: string;
}
